import React, { useContext, useEffect } from 'react'

import drawPreview from './draw'
import { Context } from '../RefinanceIndex'

import '../../styles/preview.css'

interface PNGPreviewProps {
  svgId: string
  svgRef: React.RefObject<SVGSVGElement>
  width: number
  height: number
}

const PNGPreview: React.FC<PNGPreviewProps> = ({ svgId, svgRef, width, height }) => {
  const margin = { top: 18, right: 22, bottom: 16, left: 24 }
  const context = useContext(Context)
  useEffect(() => {
    if (svgRef.current) {
      drawPreview(svgRef.current, margin, context, height)
    }
  })
  return (
    <svg id={svgId} ref={svgRef} viewBox={`0 0 ${width} ${height}`} className="png-preview">
      <g className="preview-container">
        <g className="preview-header" />
        <g className="preview-filters" />
        <g className="preview-x-axis" />
        <g className="preview-y-axis" />
        <g className="preview-legend" />
        <g className="preview-date" />
      </g>
    </svg>
  )
}

export default PNGPreview
